import List from "@/components/list";
import { tableBaseProps } from '@/utils/common.js';

const Table = (args) => {
  const { listeners, props } = args;
  const selectionChange = listeners["selectionChange"] || function () { };
  const toResPage = listeners["toResPage"] || function () { };
  const audit = listeners["audit"] || function () { };
  const auditDetail = listeners["auditDetail"] || function () { };
  const sortChange = listeners["sortChange"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const { row } = vo;
    let dealConf = []

    const auditFlag = row.auditStatus === 0

    dealConf.push([
      auditFlag ? "icon-audit" : "icon-steps",
      auditFlag ? "审核" : "查看审核详情",
      () => {
        if (row.auditStatus === 0) {
          audit(row);
        } else {
          auditDetail(row)
        }
      },
      "classReport:audit:batch"
    ]);

    dealConf.push([
      "icon-resource-config",
      "办班资料",
      () => {
        toResPage(row)
      },
      "classReportPlanFileLibrary:page"
    ]);

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  }

  const DescThree = ({ props: { vo, value } }) => {
    const row = vo.row;
    const content = row[value];
    return (
      <div class="ellipsis--l3" title={content}>
        {content}
      </div>
    )
  }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      ...tableBaseProps("班级名称", "className", "m220"),
      render: (vo) => <DescThree vo={vo} value='className' />,
    },
    {
      ...tableBaseProps("培训内容", "desc", "m220"),
      render: (vo) => <DescThree vo={vo} value='desc' />,
    },
    {
      ...tableBaseProps("培训对象", "trainPerson", "m220"),
      render: (vo) => <DescThree vo={vo} value='trainPerson' />,
    },
    tableBaseProps("调训人数", "trainNum", "m100"),
    tableBaseProps("培训时间", "trainTime", "m120"),
    tableBaseProps("申报部门", "reportDeptName", "m120"),
    tableBaseProps("提交人", "auditUserName", "90"),
    tableBaseProps("审核状态", "auditStatusName", "100"),
    {
      ...tableBaseProps("提审时间", "auditTime", "150"),
      sortable: 'custom'
    },
    {
      label: "操作",
      fixed: "right",
      width: '80',
      render: vo => <Deal vo={vo} />
    }
  ]
  return <List {...args} talbeCols={AccountTableConfig} onSelectionChange={selectionChange} onSortChange={sortChange} />;
}
export default Table;
